import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './main.css';

ReactDOM.render(<App />, document.querySelector('#root'));
